import {RegisterValues} from '@/forms/Register'
import {FormikState} from 'formik'
import {Dispatch, RefObject, SetStateAction, useRef} from 'react'
import IntlTelInput from 'react-intl-tel-input'
import 'react-intl-tel-input/dist/main.css'

interface Props {
  values: any
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  setFieldError: (field: string, message: string | undefined) => void
  setIso2: Dispatch<SetStateAction<string>>
  isError: boolean | string | undefined
  error: string | undefined
  label: string | undefined
  fieldPhoneName?: string
  fieldCountryCodeName?: string
}
export default function PhoneInput({
  values,
  setFieldValue,
  setFieldError,
  isError,
  fieldPhoneName = 'phone',
  fieldCountryCodeName = 'country_code',
  error,
  label,
  setIso2,
}: Props) {
  return (
    <div style={{direction: 'ltr'}}>
      <input type="hidden" name="country_code" value={values.country_code} />

      <label htmlFor={'phone'} className="w-full text-right block text-xs">
        {label}
      </label>
      <IntlTelInput
        defaultCountry={'il'}
        defaultValue={values[fieldPhoneName]}
        onSelectFlag={(currentNumber, selectedCountryData) => {
          setFieldValue(fieldCountryCodeName, selectedCountryData.dialCode)
        }}
        formatOnInit={false}
        onPhoneNumberChange={(isValid, value, selectedCountryData) => {
          console.log(value, 'value')
          setFieldValue(fieldPhoneName, value)
          setIso2(selectedCountryData.iso2?.toUpperCase() ?? 'IL')
          setFieldValue(fieldCountryCodeName, selectedCountryData.dialCode)
          //if (!isValid) {
          //setFieldError(fieldPhoneName, 'Phone Number is Invalid')
          //}
        }}
        placeholder={`اكتب رقم الهاتف بدون فواصل مثل 0502365478`}
        inputClassName={`phone-input placeholder:font-light  mt-5 w-full  rounded-md py-3 px-3 focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent text-xs
${isError ? 'border-1 border-red' : 'border-1 border-gray-300'}
        `}
      />
      {isError && (
        <div className="mt-1 text-left text-sm text-red font-semibold">
          {error}
        </div>
      )}
    </div>
  )
}
